import clsx from 'clsx';
import { Outlet } from 'react-router';
import { NavigationView } from './nav';

export function RootLayout() {
  
  return (
    <main className={clsx('h-dvh w-full flex flex-col mx-auto')}>
      <div className="flex-1 overflow-auto no-scrollbar pb-12">
        <Outlet />
      </div>

      <NavigationView />
    </main>
  );
}


